/*
 * Sticky boolean flag: `?<param>=1` enables, `=0` disables, and the value persists
 * so the choice survives the LTI launch redirect chain, which does not preserve
 * query params.
 *
 * sessionStorage rather than localStorage: LTI runs in a third-party LMS iframe
 * where ITP and "block trackers" deny persistent storage — the same reason ltik
 * lives there (docs/ARCHITECTURE.md §3). Consequence: a flag lasts the launch
 * session, not forever.
 */
// Resolved once per key. The URL is read only to WRITE storage; every later read
// comes from the memo, because getAppLocale() runs on every Apollo request
// (client.ts) and must not re-parse the URL or re-write storage each time. No flag
// can change without a reload — setAppLocale reloads by design.
const resolvedFlags = new Map();
const resolveStickyFlag = (urlParam, storageKey) => {
    const fromUrl = new URLSearchParams(window.location.search).get(urlParam);
    try {
        if (fromUrl === "0" || fromUrl === "1") {
            sessionStorage.setItem(storageKey, fromUrl);
            return fromUrl === "1";
        }
        return sessionStorage.getItem(storageKey) === "1";
    }
    catch {
        // Storage denied by the embedding LMS: honour the URL param for this load
        // only, with no way to persist it.
        return fromUrl === "1";
    }
};
export const readStickyFlag = (urlParam, storageKey) => {
    const cachedFlag = resolvedFlags.get(storageKey);
    if (cachedFlag !== undefined) {
        return cachedFlag;
    }
    const resolvedFlag = resolveStickyFlag(urlParam, storageKey);
    resolvedFlags.set(storageKey, resolvedFlag);
    return resolvedFlag;
};
